import React from 'react';
import PropTypes from 'prop-types';

import IconConnector from './icon-connector.jsx';
import IconArrow from './icon-arrow.jsx';

import rewardLocked from 'imported-assets/img/reward_locked.png';

const UnstartedIcon = ({ showConnector, showArrow }) => (
    <div className="unstarted-icon">
        {showConnector && <IconConnector />}
        {showArrow && <IconArrow />}
        <div
            className="rewards-icon-unstarted-image"
            style={{ backgroundImage: `url(${rewardLocked})` }}
        />
    </div>
);

UnstartedIcon.propTypes = {
    showArrow: PropTypes.bool,
    showConnector: PropTypes.bool,
};

UnstartedIcon.displayName = 'UnstartedIcon';

export default UnstartedIcon;
